import { createSlice } from '@reduxjs/toolkit'

export const loadTimeSlice = createSlice({
  name: 'loadTime',
  initialState: {
    loadStartTime: null,
    totalLoadTime: null,
    totalLoadTimeEventSet: false,
    timedOut: false,
  },
  reducers: {
    setLoadStartTime: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.loadStartTime = action.payload;
    },
    setTimedOut: (state, action) => {
      state.timedOut = action.payload;
    },
    setTotalLoadTime: (state, action) => {
      state.totalLoadTime = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setLoadStartTime, setTimedOut, setTotalLoadTime } = loadTimeSlice.actions

export default loadTimeSlice.reducer